import React from "react";
import Form from "../components/contactSection/Form";
import * as ContactS from "./styles/contactS";


const Contact = () => {
  return (
    <>
      <ContactS.Wrapper />
      <Form />
    </>
  );
};

export default Contact;
